<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <ListPageShell>
    <template #header>
      <div class="list-page-panel is-header-minimal mx-6 pt-6">
        <div class="list-page-heading">
          <div class="list-page-heading-main">
            <h1 class="list-page-title">资金申请详情</h1>
            <p class="list-page-description">用于审批中心查看财富资金操作的业务详情。</p>
          </div>
          <div class="list-page-heading-actions">
            <button type="button" class="btn-secondary" @click="goBack">返回</button>
          </div>
        </div>
      </div>
    </template>

    <div class="mx-6">
      <WealthOperationApplyBusinessDetail :apply-id="applyId" />
    </div>
  </ListPageShell>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import ListPageShell from '@/components/ListPageShell.vue'
import WealthOperationApplyBusinessDetail from '../components/WealthOperationApplyBusinessDetail.vue'

const route = useRoute()
const router = useRouter()
const applyId = computed(() => Number(route.params.id))

function goBack() {
  if (window.history.length > 1) {
    router.back()
  } else {
    router.push('/wealth/customers')
  }
}
</script>
